import baseRoute from '../baseRoute';

export type * from './requestModel';
export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/digitalSignature`;

export const ROUTE: RouteDefinition = `${baseRoute}/digitalSignature`;

export const URL = (): RouteDefinition => `${baseRoute}/digitalSignature`;
